import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";

import { connectionsApi } from "@/react/api/connectionsApi";

export const useIgnoreConnection = (
  options?: UseMutationOptions<unknown, Error, string>,
) =>
  useMutation({
    mutationFn: (connectionId: string) =>
      connectionsApi.ignoreConnection(connectionId),
    ...options,
  });
